export enum TreeDetail {
  EMPTY='-1', // 取消选择
  ADDNEW='-2', // 新增业务参数
  ZERO='0'// 默认

}
